export const validateEmail = (email) => {
  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return re.test(String(email).toLowerCase()) ? "" : "Dirección de correo inválida";
};

export const validatePhone = (phone) => {
  const re = /^\+?[1-9]\d{7,17}$/;
  return re.test(phone) ? "" : "Formato de teléfono inválido";
};

export const validateRequired = (value) => {
  return value.trim() ? "" : "Este campo es requerido";
};

const validatePassport = (value) => {
  const re = /^[A-Za-z]{1,2}[A-Za-z0-9]{5,7}$/;
  return re.test(value) ? "" : "Formato de pasaporte inválido";
};

const validateIsDNIorCUIL = (value) => {
  const re = /^\d{7,11}$/;
  return re.test(value) ? "" : "Formato de DNI o CUIL inválido";
};

export const validateIdNumber = (value, idType) => {
  if (!value.trim()) return "Este campo es requerido";

  switch (idType) {
    case "passport":
      return validatePassport(value);
    case "nationalId":
      return validateIsDNIorCUIL(value);
    default:
      return "Por favor indicar un tipo de documento";
  }
};
